<template>
  <div class="home">
    <main role="main" class="px-4">
      <div class="col col-lg-4 mx-auto pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Autentification</h1>
      </div>
      <div>
        <form @submit="submitForm" class="col col-lg-4 mx-auto">
          <div class="form-group">
            <input v-model="login" @input="resetLayout" ref="emailInput" type="email" class="form-control" :class="{'is-invalid' : isInvalid }" id="loginInput" aria-describedby="emailHelp" placeholder="Email">
          </div>
          <div class="form-group">
            <input v-model="password" @input="resetLayout" type="password" class="form-control" id="passwordInput" :class="{'is-invalid' : isInvalid }" placeholder="Mot de passe">
            <div class="invalid-feedback">Email et/ou password invalide</div>
          </div>
          <button type="submit" class="btn btn-primary" @click="signIn">Valider</button>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import { logInUser } from '@/api/crm-api.js'
import md5 from 'md5'

export default {
  data () {
    return {
      login: '',
      password: '',
      isInvalid: false
    }
  },
  computed: {

  },
  methods: {
    resetLayout () {
      this.isInvalid = false
    },
    submitForm (e) {
      e.preventDefault()
    },
    signIn () {
      logInUser({login: this.login, password: md5(this.password)})
      .then((response) => {
        if (response != null && response.data != null && response.data.id != null) {
          this.$ga.set('userId', response.data.id)
          this.$store.commit('setUser',{ password: md5(this.password), ...response.data})
          this.$ga.event({ eventCategory: 'Authentication',eventAction: 'login',eventLabel: response.data.id })
        } else {
          this.$store.commit('addMessage',{ text: response.data, status:'danger' })
          this.$store.commit('reset')
          this.isInvalid = true
        }
      })
      .catch(() => {
        this.$store.commit('reset')
        this.isInvalid = true
      })
    }
  },
  mounted () {
    if(localStorage.login && localStorage.password)
    {
      logInUser({login: localStorage.login, password: localStorage.password})
      .then((response) => {
        if(response != null && response.data != null && response.data.id != null) {
          this.$ga.set('userId', response.data.id)
          this.$store.commit('setUser',{ password: localStorage.password, ...response.data})
          this.$ga.event({ eventCategory: 'Authentication',eventAction: 'login',eventLabel: response.data.id })
        } else {
          this.$store.commit('addMessage',{ text: response.data, status:'danger' })
          this.$store.commit('reset')
        }
      })
      .catch(function () {
        this.$store.commit('reset')
      })
    }
  }
}
</script>
